import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import SupportRequestPresenter from '../../../../presenters/SupportRequestPresenter';
import ListSkeleton from '../../../../components/Skeletons/ListSkeleton';
import {
  LIST_SKELETON_HEIGHT,
  LIST_SKELETON_WIDTH,
} from '../../../../pages/constants';
import { useFetchStatus } from '../../../../utils/fetchStatusUtils';
import Pagination from '../../../../components/Pagination';

import SupportRequest from './components/SupportRequest';

const SupportRequestsTable = (props) => {
  const { requests, meta, onPageChange, loadingStatus } = props;

  const { isFulfilled } = useFetchStatus(loadingStatus);

  if (!isFulfilled) {
    return (
      <ListSkeleton height={LIST_SKELETON_HEIGHT} width={LIST_SKELETON_WIDTH} />
    );
  }

  if (isEmpty(requests)) {
    return <div className="empty-table">No data</div>;
  }

  return (
    <div>
      <table className="tables">
        <thead>
          <tr>
            <th>Date</th>
            <th>User</th>
            <th>Transaction Date</th>
            <th>Transaction Amount</th>
            <th>Store</th>
            <th>State</th>
            <th>Comment</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((request) => {
            return (
              <SupportRequest
                key={request.id}
                request={request}
                requests={requests}
              />
            );
          })}
        </tbody>
      </table>
      <Pagination meta={meta} onPageChange={onPageChange} />
    </div>
  );
};

SupportRequestsTable.propTypes = {
  requests: PropTypes.arrayOf(SupportRequestPresenter.shape()).isRequired,
  meta: PropTypes.shape().isRequired,
  onPageChange: PropTypes.func.isRequired,
  loadingStatus: PropTypes.string.isRequired,
};

export default SupportRequestsTable;
